import styled from 'styled-components';

export const MobileTriggerWrapper = styled.div`
  width: 100%;
`;

export const TriggerButton = styled.button<{
  $isError?: boolean;
  $hasValue?: boolean;
}>`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid
    ${({ theme, $isError }) =>
      $isError ? theme.colors.systemColors.red : theme.colors.border.secondary};
  border-radius: 14px;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const TriggerTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
`;

export const TriggerLabel = styled.span<{ $isError?: boolean }>`
  font-size: 14px;
  color: ${({ theme, $isError }) =>
    $isError ? theme.colors.systemColors.red : theme.colors.text.secondary};
`;

export const TriggerValue = styled.span<{ $hasValue: boolean }>`
  font-size: 15px;
  color: ${({ theme, $hasValue }) =>
    $hasValue ? theme.colors.text.primary : theme.colors.text.secondary};
`;

export const PickerContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 0;
  overflow: hidden;
`;

export const SaveButton = styled.button`
  height: 48px;
  width: 100%;
  border: none;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.systemColors.blue};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const PickerFooter = styled.div`
  padding: 10px 20px 15px;
`;
